import script from "./RouteStats.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteStats.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__